.input {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 2.875rem;
  border-radius: 0.625rem;
  overflow: hidden;
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  cursor: text;
  background-color: var(--neutral-50);
  box-shadow: 0 0 0.125rem 0 rgba(28, 30, 29, 0.33);

  @media (min-width: 769px) {
    height: 2.625rem;
    font-size: 1rem;
  }

  &:hover {
    &:not(.invalid, .focused, .disabled, .readOnly) {
      border: none;
      box-shadow: 0 0 0.125rem 0 rgba(28, 30, 29, 0.55);
    }
  }

  &.disabled,
  &.readOnly {
    background-color: var(--neutral-50);
    box-shadow: 0 0 0 0.0625rem var(--neutral-200);
  }

  &.invalid {
    border: none;
    box-shadow: 0 0 0 0.0625rem var(--danger);
  }

  &.focused {
    &:not(.invalid, .disabled, .readOnly) {
      border: none;
      background-color: var(--neutral);
      box-shadow: 0 0 0 0.0625rem var(--primary-600);
    }
  }

  &.disabled {
    cursor: no-drop;
  }

  &.rounded {
    border-radius: 10rem;

    &.clear {
      .clearButton {
        right: 0.1875rem;
      }
    }

    .icon {
      margin-left: 0.75rem;
    }

    .input {
      padding: 0.5rem 0.875rem;
    }
  }

  &.clear {
    .clearButton {
      position: absolute;
      top: 50%;
      right: 0.25rem;
      width: 2rem;
      height: 2rem;
      transform: translateY(-50%);

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }

    .input {
      padding-right: 3rem;
    }
  }

  .icon {
    display: flex;
    flex: 0 0 auto;
    width: 1.25rem;
    margin: 0 -0.3125rem 0 0.625rem;
    cursor: default;

    svg {
      width: 100%;
      height: 100%;
      color: var(--neutral-500);
    }
  }

  .field {
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.875rem;
    border: none;
    border-radius: 0;
    outline: none;
    color: var(--neutral-600);
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    cursor: inherit;
    background-color: transparent;
    box-shadow: none;

    &[type='number'] {
      appearance: textfield;
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
    }

    &::placeholder {
      color: var(--neutral-500);
      font-weight: 400;
      user-select: none;
      pointer-events: none;
    }

    &:focus,
    &:active {
      &::placeholder {
        opacity: 0;
      }
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin: 0;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
    }
  }
}
